export const constants = {
  trackingId: 'G-XCZQJCWPYT', // OUR_TRACKING_ID // TODO add for GA4
  toastLoadingOptions: {
    isLoading: false,
    autoClose: 4000,
    closeButton: true,
    draggable: true,
  },
};
